import { useState } from 'react';
import { useSelector, shallowEqual } from 'react-redux';

import { FORM_VALIDATION_ERROR } from 'src/app/constants/errorMessages';
import getTrackingAdapter from 'src/app/dataAnalytics';
import {
  FEATURE_DATA_ANALYTICS,
  useFeatureToggleData,
} from 'src/app/featureToggle';
import sendPageError from 'src/app/utils/analytics/sendPageError';
import type AppState from 'src/types/appState';

export const useErrorType = () => {
  const { tealium } = useSelector(
    (state: AppState) => ({
      tealium: state.tealium,
    }),
    shallowEqual,
  );

  const isPageAnalyticsEnabled = useFeatureToggleData(FEATURE_DATA_ANALYTICS);

  const [errorType, setErrorType] = useState('');

  const sendErrorEvent = (errorMessage: string) => {
    if (isPageAnalyticsEnabled) {
      const eventData = {
        eventName: FORM_VALIDATION_ERROR,
        errorMessage,
      };
      getTrackingAdapter.sendLinkEvent(eventData);
    } else {
      sendPageError(tealium, errorMessage);
    }
  };

  const setError = (error: Error | string) => {
    if (error instanceof Error && typeof error.message === 'string') {
      setErrorType(error.message);
      sendErrorEvent(error.message);
    } else if (typeof error === 'string') {
      setErrorType(error);
      sendErrorEvent(error);
    }
  };

  const resetError = () => {
    setErrorType('');
  };

  return {
    errorType,
    setError,
    resetError,
  };
};
